import React, { Component } from 'react'
import { connect } from 'react-redux'
import { setSelectedZone, TempChangeInncom, setzoneCount, setSelectedAC, setAcSelected } from '../../../../action/roomControlAction'
import { roomThemeColorConfig } from '../../../JS/colorConfig'
import AcControl from './acControl'
import { CMSPath, DEMO, PREFER_ECP_OVER_UNIT_FROM_API_FOR_TEMPERATURE_UNIT } from '../../../../config/constant'

class ACSelector extends Component {

    componentDidMount() {
        roomThemeColorConfig(this.props.menuColor);
        this.checkForSingleZone({}, "first call");
    }
    componentDidUpdate(prePro) {
        this.checkForSingleZone(prePro, "");
    }

    celsiusToFahrenheit = (temp, log=false) => {
        
        let newTemp = ((temp * 1.8) + 32).toFixed(0);
       
        return newTemp <= 32 ? 32 : newTemp >= 212 ? 212 : newTemp;
    }

    fahrenheitToCelsius = (temp, log=false) => {
    
        let newTemp = ((temp - 32) * 0.5556).toFixed(0);

        return newTemp <= 0 ? 0 : newTemp >= 100 ? 100 : newTemp;;
    
    }

    checkForSingleZone = (prePro, firstcall) => {
        let count = 0, index = null
        if ((firstcall === "first call" || prePro.VDAZoneList !== this.props.VDAZoneList) && this.props.VDAZoneList.length !== 1) {
            this.props.VDAZoneList.map((iterator, ind) => {
                if (iterator.hvac && iterator.hvac.temperatureValue) {
                    ++count;
                    index = ind
                }
            })
            if (count === 1) {
                console.log("we have only one zone but shows two.");
                let temp = parseInt(this.props.VDAZoneList[index].hvac.temperatureValue.slice(2, 4));
                let roomTemp = parseInt(this.props.VDAZoneList[index].hvac.currentRoomTemperature.slice(2, 4));
                this.props.setSelectedZone(this.props.VDAZoneList[index], roomTemp, index);
                this.props.TempChange(null, temp);

            }
            this.props.setzoneCount(count);
        }
    }
    selectAc = (hvac, index) => {
        console.log('hvac, index',hvac, index, hvac.temperatureUnit)

        let unit, temp, roomTemp

        if(PREFER_ECP_OVER_UNIT_FROM_API_FOR_TEMPERATURE_UNIT){
            if(this.props.weather_temp_unit){
                unit = this.props.weather_temp_unit == 'fahrenheit' ? 'F' : this.props.weather_temp_unit == 'celsius' ? 'C' : ''
           } else {
               unit = hvac.temperatureUnit
           }

        } else {

            if(!hvac.temperatureUnit){
                unit = this.props.weather_temp_unit == 'fahrenheit' ? 'F' : this.props.weather_temp_unit == 'celsius' ? 'C' : ''
            } else {
                unit = hvac.temperatureUnit
            }
        }

        if(!hvac.temperatureValue){
            temp = parseInt( unit == 'C' ?  this.props.configs.celciusMin : this.props.configs.farenheitMin);
        } else {
            temp = parseInt(hvac.temperatureValue.slice(2, 4));
            
            if( PREFER_ECP_OVER_UNIT_FROM_API_FOR_TEMPERATURE_UNIT && unit != hvac.temperatureUnit){
                if(unit=="C"){
                    temp = this.fahrenheitToCelsius(temp);
                } else if(unit == "F") {
                    temp = this.celsiusToFahrenheit(temp);
                }
            }
            this.props.TempChangeInncom(null, temp);
        }

        if(!hvac.currentRoomTemperature){
            roomTemp = parseInt( unit == 'C' ?  this.props.configs.celciusMin : this.props.configs.farenheitMin);
        } else {
            roomTemp = parseInt(hvac.currentRoomTemperature.slice(2, 4));

            if( PREFER_ECP_OVER_UNIT_FROM_API_FOR_TEMPERATURE_UNIT && hvac.currentRoomTemperature && unit != hvac.temperatureUnit){
                if(unit=="C"){
                    roomTemp = this.fahrenheitToCelsius(roomTemp);
                } else if(unit == "F") {
                    roomTemp = this.celsiusToFahrenheit(roomTemp);
                }
            }
        }

        this.props.setSelectedAC(hvac, roomTemp, index);

        this.props.updateState(hvac.acMode, temp, roomTemp, unit, hvac.fanSpeed, this.props.configs.farenheitMin, this.props.configs.farenheitMax, this.props.configs.celciusMin, this.props.configs.celciusMax)
        this.props.setAcSelected(true)
    }

    componentDidMount(){
        /*if(DEMO){
            this.setZone(this.props.VDAZoneList[0], 0);
        }*/
        console.log('Rendered ACSelector')
        console.log('weather_temp_unit',this.props.weather_temp_unit)

    }

    render() {
        return (
            this.props.hvac.length > 1 ?
            <section id="customizeRoom" class="widgets padding-bottom-2 margin-0">

                <div class="widget-header widget-header-checkin">
                    { this.props.currentWidget.widgetHeaderImageUrl && 
                        <div class="widget-header-img">
                            <img src={`${CMSPath}${this.props.currentWidget.widgetHeaderImageUrl}`} alt={this.props.currentWidget.displayName} />
                        </div>
                    }
                    <div class="widget-header-title">{(this.props.hvac.length > 1 && this.props.selectedAC.acLabel ) ? this.props.selectedAC.acLabel : this.props.currentWidget.displayName}</div>
                </div>


                <div class="widgets">
                    <div class="row">
                        <div class="col">
                            <p class="heading" style = {{color: this.props.menuColor.assetFontSelectorColor}}>Select Room</p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col col-2 menu-items">
                            {
                                    this.props.hvac.map((iterator, index) => {
                                        return (
                                            <a onClick={() => this.selectAc(iterator, index)}
                                                className={
                                                    true ? "tile-sm thumbnails tile-container"
                                                        : "tile-sm thumbnails tile-container selected"
                                                }>{console.log('hvac, index', iterator, index)}
                                                <div class="thumb-img">
                                                    <i class="fas fa-temperature-low"></i>
                                                </div>
                                                <div class="thumb-text align-center" style={{ color: "inherit" }}>
                                                    <p class="thumb-heading" style={{ color: "inherit" }}>{iterator.acLabel ? iterator.acLabel : `HVAC ${index}`}</p>
                                                </div>
                                            </a>
                                        )
                                    })
                            }
                        </div>
                    </div>
                </div>
            </section>
            : 
                this.props.hvac.map((iterator, index) => {
                    console.log('only one ac')
                    this.selectAc(iterator, index)
                })
        )
    }
}

const mapStateToProps = state => {
    return {
        currentPage: state.store2.roomControl.currentPage,
        //guestDetail: state.store.home.guestDetails,
        currentWidget: state.store.sideNavBar.currentWidget,
        selectedAC: state.store.InncomRoomControl?
        state.store.InncomRoomControl.selectedAC : [],
        configs: state.store.InncomRoomControl.configs,
        VDAZoneList: state.store.roomControl.VDAZoneList,
        selectedZone: state.store.roomControl.selectedZone,
        hvac: state.store.InncomRoomControl.hvac,
        menuColor: state.store.home.MenuColor,
        celciusMin: state.store.InncomRoomControl.celciusMin,
        farenheitMax: state.store.InncomRoomControl.farenheitMax,
        farenheitMin: state.store.InncomRoomControl.farenheitMin,
        weather_temp_unit: state.store.home.clientConfig.extraConfigParam 
        ? state.store.home.clientConfig.extraConfigParam.WEATHER_TEMPERATURE_UNIT : ""
    }
}
export default connect(
    mapStateToProps,
    {
        setSelectedZone,
        TempChangeInncom,
        setzoneCount,
        setSelectedAC,
        setAcSelected
    }
)(ACSelector);